import CartIcon from '@components/icons/cart-icon'
import Button from '@components/ui/button'
import { isSpecialOrder } from '@utils/helper'
import { useTranslation } from 'next-i18next'
import cn from 'classnames'
import { useContext } from 'react'
import { IUser } from '@contexts/user/user.utils'
import { UserContext } from '@contexts/user/user.context'
interface AddToCartButtonProps {
  isShowSpecialOrderDesc?: boolean
  setIsShowSpecialOrderDesc?: (value: boolean) => void
  addToCart: () => void
  addToCartLoader: boolean
  isSelected?: boolean
  className?: string
  data: any
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  isShowSpecialOrderDesc,
  setIsShowSpecialOrderDesc,
  addToCart,
  addToCartLoader,
  isSelected = true,
  className,
  data,
}) => {
  const { cartId, isProductAdded } = useContext(UserContext) as IUser
  const { t: translate } = useTranslation('common')
  let loading = addToCartLoader && isProductAdded?.sku === data?.sku
  let disabledOtherItem = addToCartLoader && isProductAdded?.sku !== data?.sku
  const isSpecialOrderFlag = isSpecialOrder(data)
  if (isSpecialOrderFlag) {
    return !isShowSpecialOrderDesc ? (
      <Button
        onClick={() => setIsShowSpecialOrderDesc(true)}
        className="w-full h-11 md:h-14 px-1.5 bg-brand-green rounded-none"
      >
        <CartIcon color="#ffffff" className="ltr:mr-3 rtl:ml-3" />
        {translate('text-add-to-cart')}
      </Button>
    ) : (
      <Button
        className={cn(
          `${
            !cartId?.id && 'cursor-wait opacity-30'
          }  bg-brand-yellow w-full h-11 md:h-16 px-1.5 rounded-none`,
          className,
        )}
        onClick={addToCart}
        disabled={data?.isActive || loading || disabledOtherItem || !cartId?.id}
        loading={loading}
      >
        {translate('text-confirm-button')}
      </Button>
    )
  }

  return (
    <Button
      onClick={addToCart}
      className={cn(
        `${
          !cartId?.id && 'cursor-wait opacity-30'
        }  w-full h-11 md:h-14 px-1.5 bg-brand-green rounded-none  [@media_(max-width:576px)]:gap-2`,
        className,
      )}
      disabled={!isSelected || loading || disabledOtherItem || !cartId?.id}
      loading={loading}
    >
      <CartIcon
        color="#ffffff"
        className="ltr:mr-3 rtl:ml-3 [@media_(max-width:576px)]:w-5"
      />
      {translate('text-add-to-cart')}
    </Button>
  )
}

export default AddToCartButton
